import type { DeepString } from "@/lib/i18n";

/**
 * AccessibilityToggle — polskie tłumaczenia (panel WCAG dla visitor'a).
 */
export const pl = {
  triggerAria: "Otwórz panel dostępności cyfrowej",
  triggerTitle: "Dostępność cyfrowa",
  dialogAria: "Panel dostępności cyfrowej",
  panelTitle: "Dostępność cyfrowa",
  closeAria: "Zamknij panel dostępności",
  fontSize: {
    heading: "Rozmiar czcionki",
    sliderAria: "Rozmiar czcionki",
    small: "Mała",
    large: "Duża",
  },
  contrast: {
    heading: "Kontrast",
    label: "Wysoki kontrast",
  },
  navigation: {
    heading: "Nawigacja",
    highlightLinks: "Podświetl linki",
  },
  shortcuts: {
    heading: "Skróty klawiszowe",
    jumpToContent: "Przejdź do treści",
    jumpToMenu: "Przejdź do menu",
  },
  reset: "Przywróć domyślne",
} as const;

export type AccessibilityToggleTranslations = DeepString<typeof pl>;
